const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export function getAuthToken() {
  return typeof window === "undefined" ? "" : window.localStorage.getItem("token") || "";
}

export function clearAuthToken() {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem("token");
  }
}

export function getTokenPayload(token = getAuthToken()) {
  if (!token) return null;

  try {
    const [, payload] = token.split(".");
    if (!payload) return null;

    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");

    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
}

export function getAuthRole(token = getAuthToken()) {
  const payload = getTokenPayload(token);
  return payload?.role || payload?.[ROLE_CLAIM] || "";
}

export function isTokenExpired(token = getAuthToken()) {
  const payload = getTokenPayload(token);
  if (!payload?.exp) return true;

  return payload.exp * 1000 <= Date.now();
}

export function isAuthenticatedForRole(requiredRole) {
  const token = getAuthToken();
  if (!token || isTokenExpired(token)) {
    clearAuthToken();
    return false;
  }

  return getAuthRole(token).toLowerCase() === requiredRole.toLowerCase();
}
